// import React, { useState } from 'react';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../Button/Button';
import UserMenu from './UserMenu';
import { useAuth } from '../../context/AuthContext';
// import useWindowDimensions from '../../hooks/useWindowDimensions';
import { useTranslation } from 'react-i18next';
import MotorikIcon from '../Icons/MotorikIcon';
import Typography from '../Typography';
import { theme } from '../../theme';
import SearchIcon from '../Icons/SearchIcon';
import TicketsIcon from '../Icons/TicketsIcon';
import CalendarOutlineIcon from '../Icons/CalendarOutlineIcon';


const MainNavbar = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t: tNavbar } = useTranslation('navbar');
  const isAuthenticated = !!user;

  const handleCreateEvent = () => {
    if (isAuthenticated) {
      navigate('/create-event');
    } else {
      navigate('/signin');
    }
  };

  return (
    <Topbar>
      <Container>
        <HomeLink to="/">
          <MotorikIconWrapper fill="white" />
          <BetaBadge>
            <Typography $variant="overline-medium" color={theme.colors.inverseWeak}>BETA</Typography>
          </BetaBadge>
        </HomeLink>
        <ActionsContainer>
          {isAuthenticated && (
            <QuickLinks>
              <QuickLink to="/discover">
                <SearchIcon fill={theme.colors.inverseMain} width={16} height={16} />
                <Typography $variant="body-2-medium" color={theme.colors.inverseMain}>
                  {/* Encuentra Plan */}
                  {tNavbar('findPlan')}
                </Typography>
              </QuickLink>
              <QuickLink to="/hosted-events">
                <TicketsIcon fill={theme.colors.inverseMain} width={16} height={16} />
                <Typography $variant="body-2-medium" color={theme.colors.inverseMain}>
                  {/* Eventos organizados */}
                  {tNavbar('myEvents')}
                </Typography>
              </QuickLink>
              <QuickLink to="/agenda">
                <CalendarOutlineIcon fill={theme.colors.inverseMain} width={16} height={16} />
                <Typography $variant="body-2-medium" color={theme.colors.inverseMain}>
                  {/* Agenda */}
                  {tNavbar('calendar')}
                </Typography>
              </QuickLink>
            </QuickLinks>
          )}
          <Button $variant="defaultInverse" size="l" sizeTablet="l" sizeMobile="m" onClick={handleCreateEvent}>
            {tNavbar('createEvent')}
          </Button>
          {!isAuthenticated && (
            <SecondaryButton $variant="outlineInverse" size="l" sizeTablet="l" sizeMobile="m" onClick={() => navigate('/signin')}>
              {tNavbar('signInOrJoin')}
            </SecondaryButton>
          )}
          <UserMenu />
        </ActionsContainer>
      </Container>
    </Topbar>
  );
};

export default MainNavbar;


//Estilos del componente

export const Topbar = styled.header`
  align-items: center;
  background-color: ${({ theme }) => theme.fill.inverseMain};
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`;

const Container = styled.div`
  align-items: center;
  color: white;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
  max-width: 1400px;
  // padding: ${({ theme }) => theme.sizing.sm} ${({ theme }) => theme.sizing.md};
  padding: 12px ${({ theme }) => theme.sizing.md};


  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    // padding: ${({ theme }) => theme.sizing.sm} ${({ theme }) => theme.sizing.sm};
    padding: 12px ${({ theme }) => theme.sizing.sm};
  }
`;

const HomeLink = styled(Link)`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.xs};
`;

const BetaBadge = styled.div`
  align-items: center;
  border: 1px solid ${({ theme }) => theme.border.inverseWeak};
  border-radius: ${({ theme }) => theme.radius.lg};
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.sizing.xxs} ${({ theme }) => theme.sizing.xs};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

const MotorikIconWrapper = styled(MotorikIcon)`
  transition: all 300ms ease-out;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 16px;
    width: auto;  
  }  

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 12px;
    width: auto;  
  }  
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const QuickLinks = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.md};
  align-items: center;
  padding-right: ${({ theme }) => theme.sizing.sm};

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: none;
  }  
`;

const QuickLink = styled(Link)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.xxs};
  justify-content: flex-start;
  align-items: center;
  transition: opacity 300ms ease-out;

  &:hover {
    opacity: 0.7;
  }
`;

const SecondaryButton = styled(Button)`
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: none;
  }  
`;
